import React, { useEffect, useState } from "react";
import ViewExpensePage from "../../../../entities/DashboardPage/AccountingModule/ViewExpense";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";

const ViewExpense = () => {
  const [banks, setBanks] = useState();
  const [types, setTypes] = useState();
  const location = useLocation()
  const {showAlert} = useAlert()
  const [loading, setLoading] = useState(false)
  const {item} = location.state || {}
  const navigate = useNavigate()
    
  useEffect(() => {
    getAllBanks()
    getExpenseType("Expense")
  },[])
  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllBanks();
      if (result?.success) {
        setBanks(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getExpenseType = async (type) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getExpenseType(type);
      if (result?.success) {
        setTypes(result?.data?.types);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const updateExpense = async (id,data,type,date,paymentMode,bankDetails,files) => {
    setLoading(true);
    try {
      const result = await AuthService.updateExpense(id,data,type,date,paymentMode,bankDetails,files);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/expense")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  return(
    <>
      <ViewExpensePage banks={banks} loading={loading} updateExpense={updateExpense} item={item} types={types}/>
    </>
  )
}

export default ViewExpense